import {DASHBOARD_TOP_TABS_VALUE} from '../../utils/constants.js';

export const getDashboardTopTabs = () => {
    return {
        dashboardTopTabDetails: {
            className: 'dashboard-tabs-container',
            toggleName: 'dashboard-top-tabs',
            toggle: [
                {
                    toggleLabel: 'Recommendation',
                    toggleValue: DASHBOARD_TOP_TABS_VALUE.RECOMMENDATION
                },
                {
                    toggleLabel: 'Competition',
                    toggleValue: DASHBOARD_TOP_TABS_VALUE.COMPETITION
                }
            ]
        }
    }
};
